<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<acc-login [loginHeading]="loginHeading">
  <h2 class="slds-text-heading_medium">Track 4<sup>D</sup>
    <small> - Track Time
      <span class="slds-text-body_small">- the 4<sup>th</sup> Dimension</span>
    </small>
  </h2>
  <summary class="slds-m-vertical_x-small">Capture and manage Time + Expenses</summary>
  <img alt="Track 4D - Copyright Accorto, Inc."
       src="/assets/images/logo.svg" style="float: right; height: 100px">
  <ul class="slds-list_dotted">
    <li>Capture Time with Timer</li>
    <li>Check In/Out with Geo Location</li>
    <li>Capture Expenses with Receipt Attachments</li>
    <li>Weekly Timesheet</li>
    <li>Not Submitted Expenses</li>
  </ul>
</acc-login>
